import React from 'react'

import { Link } from 'react-router-dom'

import { CheckOutlined } from '@ant-design/icons'
import { Tag, Button, Popconfirm } from 'antd'

import { LAYOUT_VENDOR_JOB_SHOW } from '../../navigation'

import { configureField } from '../../../../core/utils/list'

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden, actionLoading, downloadScorecard, accept } = props

  if (loading) {
    return []
  }

  return [
    {
      title: 'ID #',
      dataIndex: 'display_id',
      fixed: 'left',
      width: 140,
      // eslint-disable-next-line react/display-name
      ...configureField('l.id', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'Name',
      dataIndex: 'vendor_name',
      fixed: 'left',
      // eslint-disable-next-line react/display-name
      render: (name, record) => <>{name}</>,
      ...configureField('v.name', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'Type',
      dataIndex: 'lqa_type',
      ...configureField('l.lqaType', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Job',
      dataIndex: 'job',
      render: (job) => {
        if (job) {
          return <Link to={LAYOUT_VENDOR_JOB_SHOW(job.id)}>{job?.displayId}</Link>
        }
      },
      ...configureField('l.job', filters, resize, hidden, false, false, true, 200)
    },

    {
      title: 'Score',
      dataIndex: 'score',
      render: (score) => {
        if (score) {
          return <Tag>{score}%</Tag>
        }
      },
      ...configureField('l.score', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Date',
      dataIndex: 'date',
      ...configureField('l.date', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Scorecard',
      dataIndex: 'scorecard',
      render: (scorecard, record) => {
        if (scorecard) {
          return (
            <Button
              type='link'
              disabled={actionLoading}
              onClick={() => downloadScorecard({ id: record.id, name: scorecard.name })}
            >
              Download
            </Button>
          )
        }
      },
      ...configureField('scorecard', filters, resize, hidden, false, false, false, 200)
    },
    {
      title: 'Vendor Status',
      dataIndex: 'vendor_status',
      render: (vendorStatus, record) => {
        if (vendorStatus === 'Pending') {
          return (
            <Popconfirm
              title='Are you sure?'
              onConfirm={() => accept(record.id)}
              okText='Yes'
              cancelText='No'
              disabled={actionLoading}
            >
              <Button type='default' size='small' disabled={actionLoading} icon={<CheckOutlined />}>
                Confirm
              </Button>
            </Popconfirm>
          )
        }
        return <Tag color='success'>{vendorStatus}</Tag>
      },
      ...configureField('l.vendorStatus', filters, resize, hidden, true, false, true, 200)
    }
  ]
}
